import { render } from "./S3Config.vue?vue&type=template&id=849a3f5a"
import script from "./S3Config.vue?vue&type=script&lang=js"
export * from "./S3Config.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__